<div #origin class="relative">
  <input
    type="text"
    class="mib-input w-full pr-11"
    autocomplete="off"
    [attr.inputmode]="mask() ? 'numeric' : null"
    [class.mib-field-error]="control.showsError()"
    [attr.id]="inputId()"
    [attr.aria-invalid]="control.showsError()"
    [attr.aria-required]="control.required() ? 'true' : null"
    [attr.aria-describedby]="describedBy()"
    [placeholder]="shownPlaceholder()"
    [value]="text()"
    [disabled]="disabled()"
    (input)="onInput($event)"
    (blur)="onBlur()"
    (click)="onFieldClick()"
    (keydown.tab)="close(false)"
    (keydown.enter)="onEnter()"
    (keydown.shift.tab)="close(false)"
    (keydown.alt.arrowdown)="toggleOpen()" />
  <button
    #toggle
    type="button"
    class="mib-field-action absolute top-1 right-1"
    aria-haspopup="dialog"
    [attr.aria-expanded]="open()"
    [attr.aria-label]="toggleLabel()"
    [disabled]="disabled()"
    (click)="toggleOpen()">
    <svg mib-icon name="calendar" class="size-4"></svg>
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="originElement()"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayOffsetY]="4"
  (attach)="onAttach()"
  (detach)="close(false)"
  (overlayOutsideClick)="onOutsideClick($event)"
  (overlayKeydown)="$event.key === 'Escape' && onEscape()">
  <div
    role="dialog"
    class="rounded-mib-lg border border-mib-divider bg-white p-3 shadow-md"
    [attr.aria-label]="panelLabel()">
    <mib-datepicker-panel
      [selected]="value()"
      [min]="minDay()"
      [max]="maxDay()"
      [locale]="locale()"
      [weekStartsOn]="weekStartsOn()"
      [previousLabel]="previousLabel()"
      [nextLabel]="nextLabel()"
      [(month)]="month"
      (picked)="pick($event)" />
  </div>
</ng-template>
